import React from "react";
import { getFileUploadName } from "src/utils/common";
import { BUTTON_UPLOAD_POSITION } from "src/constant/common";
import TooltipWrapper from "../TooltipWrapper";

const FileNameDisplay = ({ item, name, buttonUploadPosition, isShowButtonUpload, updateAt }) => {
  const fileName = getFileUploadName(item);

  if (buttonUploadPosition === BUTTON_UPLOAD_POSITION.END) {
    return (
      <>
        {isShowButtonUpload ? (
          <FileNameWithTooltip fileName={fileName} name={name} updateAt={updateAt} />
        ) : (
          <p className="mb-0 text-break">{fileName}</p>
        )}
      </>
    );
  }

  return <p className="text-muted fw-bold fs-15 mb-0 text-break">{fileName}</p>;
};

const FileNameWithTooltip = ({ fileName, name, updateAt }) => {
  const tooltipId = `tooltip-file-${name}`;

  return (
    <div>
      <TooltipWrapper
        id={tooltipId}
        tooltipText={`${fileName} ${updateAt ? `(${updateAt})` : ""}` || ""}
        checkOverflow={true}
        tooltipClassName="max-width-by-px-300"
      >
        <p className="mb-0 min-width-by-px-80 max-width-by-px-256 overflow-hidden text-truncate">{`${fileName} ${
          updateAt ? `(${updateAt})` : ""
        }`}</p>
      </TooltipWrapper>
    </div>
  );
};

export default FileNameDisplay;
